import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  path: {
    "&:hover": {
      fill: theme.palette.fuchsia.main,
    },
  },
}));
